module.exports = __webpack_public_path__ + "5cc92aebb3aa1f763a8f933c235a3bdb.svg";